import { Box, styled, Typography } from '@mui/material';

export const ElementContainer = styled(Box)(({ theme }) => ({
  borderBottom: `1px solid ${theme.palette.colors.scrollOnPrimaryBackground}`,
  marginTop: '16px',
  marginBottom: '16px',

  [theme.breakpoints.up('lg')]: {
    marginTop: 0,

    '&:not(:nth-child(2))': {
      marginTop: '8px',
    },
  },
}));

export const ElementHeader = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginBottom: '8px',

  [theme.breakpoints.up('lg')]: {
    marginBottom: '16px',
  },
}));

export const ElementLabel = styled(Typography)(({ theme }) => ({
  fontSize: '14px',
  fontWeight: 700,
  lineHeight: 'normal',
  letterSpacing: 'normal',
  color: theme.palette.colors.onPrimaryBackground,
}));
